<template>
  <ValidationObserver
    ref="buttonsObserver"
    :class="{ center }" >
    <div
      v-if="schema.subtitle"
      class="subtitle flex flex-align-center mt-0">
      <svg
        v-if="schema.subtitlePrefixIcon && typeof schema.subtitlePrefixIcon === 'string' && schema.subtitlePrefixIcon.endsWith('.svg')"
        class="mr-1 flex-start-image"
        :data-src="schema.subtitlePrefixIcon"
        fill="currentColor"
        width="10"
        height="10" />
      <img
        v-else-if="schema.subtitlePrefixIcon && typeof schema.subtitlePrefixIcon === 'string'"
        :src="schema.subtitlePrefixIcon"
        style="width: 8px; height: 8px;"
        class="mr-1 flex-start-image"
      >
      <SBIcon
        v-else-if="!schema.noSubtitlePrefixIcon"
        class="mr-1"
        :icon="SBIconList.INFO"
        :color="SBColors.greyLight"
        :size="10" />
      <span>{{ schema.subtitle }}</span>
    </div>
    <div
      v-for="(button, index) in buttons"
      :key="index"
      class="button-fields" >
      <ValidationProvider
        v-slot="{ errors, failedRules }"
        :name="`Button ${index + 1}`"
        :rules="proccessedValidators" >
        <b-form-group>
          <!-- <label
            :for="`buttonInput-${index}`"
            class="button__label flex flex-align-center" >
            <span class="greedy">Button text</span>
            <span class="character-counter">{{ buttonMaxTextLength - button.value.length }}</span>
          </label> -->
          <div class="option">
            <input
              :id="`buttonInput-${index}`"
              :ref="`buttonInputRef-${index}`"
              v-model="button.value"
              :maxlength="schema.maxTextPreventInput ? buttonMaxTextLength : null"
              type="text"
              class="w-100 sb2-bordered option-item mb-0"
              :class="{ 'sb2-active sb2-hoverable sb2-focusable': !button.readOnly, empty: !button.value }"
              :placeholder="schema.placeholder || 'Enter button text'"
              :readonly="button.readOnly"
              @keyup.enter="enterPressed" >
            <SBIcon
              v-if="!button.readOnly && showRemoveButton"
              class="mr-2 delete"
              :icon="SBIconList.CLOSE_THIN"
              :size="10"
              :hover-size="20"
              :color="SBColors.greyPrimary"
              :background-color="SBColors.white"
              :hover-icon-color="SBColors.blackPrimary"
              @click="removeOption(index)" />
          </div>
          <div
            v-if="errors[0]"
            class="error flex"
            :class="[center ? 'center-all' : 'flex-align-center', { warning: warningValidators.includes(Object.keys(failedRules)[0])}]">
            <SBIcon
              class="mr-1"
              :icon="warningValidators.includes(Object.keys(failedRules)[0]) ? SBIconList.INFO : SBIconList.ERROR"
              :color="warningValidators.includes(Object.keys(failedRules)[0]) ? '#DEBD30' : SBColors.redPrimary"
              :size="10" />
            <span>{{ schema.validatorMessages && schema.validatorMessages[Object.keys(failedRules)[0]] ? validatorMessagesProcessed[Object.keys(failedRules)[0]] : errors[0] }}</span>
          </div>
        </b-form-group>
      </ValidationProvider>
      <div
        v-if="button.subtitle"
        class="subtitle flex flex-align-center mb-0">
        <img
          v-if="button.subtitlePrefixIcon && typeof button.subtitlePrefixIcon === 'string'"
          :src="schema.subtitlePrefixIcon"
          style="width: 10px; height: 10px;"
          class="mr-1"
        >
        <SBIcon
          v-else-if="button.subtitlePrefixIcon"
          class="mr-1"
          :icon="button.subtitlePrefixIcon"
          :color="SBColors.greyLight"
          :size="10" />
        <span>{{ button.subtitle }}</span>
      </div>
    </div>
    <span
      v-if="!schema.noAddButton && schema.maxButtons && buttons.length < schema.maxButtons"
      class="add-more-btn"
      :class="{
        disabled: !valid,
        black: schema.blackButtons,
      }"
      @click="addNewButtons">
      <span class="flex flex-align-center">
        <svg
          v-if="schema.addButtonIcon && typeof schema.addButtonIcon === 'string' && schema.addButtonIcon.endsWith('.svg')"
          class="mr-1 flex-start-image"
          :data-src="schema.addButtonIcon"
          fill="currentColor"
          width="10"
          height="10" />
        <img
          v-else-if="schema.addButtonIcon && typeof schema.addButtonIcon === 'string'"
          :src="schema.addButtonIcon"
          style="width: 8px; height: 8px;"
          class="mr-1"
        >
        <SBIcon
          v-else-if="!schema.noSubtitlePrefixIcon"
          class="mr-2"
          :icon="SBIconList.PLUS"
          :color="schema.blackButtons ? SBColors.blackPrimary : SBColors.bluePrimary"
          :size="8" />
        <span>{{ schema.addButtonText || 'Add' }}</span>
      </span>
    </span>
  </ValidationObserver>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'ButtonsWrapper',
  components: {
    SBIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    validators: {
      type: String,
      default: '',
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
    center: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buttons: [
        // { value: '' },
        // { value: '' },
        // { value: '' },
        // { value: '' },
        // { value: '' },
      ],
      flowName: '',
      valid: true,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    buttonMaxTextLength() {
      return this.validatorsKeyValue.maxLength || null;
    },
    showRemoveButton() {
      return this.buttons.length > this.schema.minButtons;
    },
    warningValidators() {
      return this.schema.warningValidators ? this.schema.warningValidators.split(',') : [];
    },
    validatorsKeyValue() {
      const v = {};
      if (this.schema.validators) {
        this.schema.validators.split('|').forEach((validator) => {
          const [key, value] = validator.split(':');
          v[key] = value;
        });
      }
      return v;
    },
    /**
     * Validator messages can hold placeholders to show the value insade a message.
     * Maybe not very usefull for basic validators, but can be very usefull for custom validators and some dynamic data.
     */
    validatorMessagesProcessed() {
      const messages = {};
      if (this.validatorsKeyValue) {
        Object.keys(this.schema.validatorMessages).forEach((key) => {
          messages[key] = this.schema.validatorMessages[key].replace(/{{validator}}/g, this.validatorsKeyValue[key]);
        });
      }
      return messages;
    },
    proccessedValidators() {
      return this.schema.validators ? this.schema.validators.replace('uniques', `uniques:${this.buttons.map(button => button.value)}`) : 'required';
    },
  },
  watch: {
    buttons: {
      handler() {
        setTimeout(() => {
          this.emitData(true);
        }, 0);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.schema.value) {
      const buttonFormat = this.schema.value.map(button => ({
        value: button.title || button,
        ...(button.readOnly && { readOnly: button.readOnly }),
        ...(button.subtitlePrefixIcon && { subtitlePrefixIcon: button.subtitlePrefixIcon }),
        ...(button.subtitle && { subtitle: button.subtitle }),
      }));
      this.buttons = buttonFormat;
    }
    if (this.buttons.length < this.schema.minButtons) {
      for (let i = this.buttons.length; i < this.schema.minButtons; i += 1) {
        this.addNewButtons(false);
      }
    }
    if (this.schema.stepID) {
      this.$eventBus.$on(`validate-${this.schema.stepID}`, () => {
        if (!this.$refs.buttonsObserver) return;
        this.$refs.buttonsObserver.validate();
      });
    }
    setTimeout(() => {
      this.emitData(true);
      if (this.schema.value) {
        if (!this.$refs.buttonsObserver) return;
        this.$refs.buttonsObserver.validate();
      }
    }, 0);
  },
  methods: {
    addNewButtons(focus = true) {
      // Do not add new buttons if the form is not valid or the max number of buttons is reached
      if (
        !this.valid ||
        this.schema.noAddButton ||
        (this.schema.maxButtons && this.buttons.length >= this.schema.maxButtons)
      ) return;

      this.buttons.push({ value: '' });
      const targetButton = `buttonInputRef-${this.buttons.length - 1}`;
      setTimeout(() => {
        if (focus) this.$refs[targetButton][0].focus();
        this.emitData();
      }, 0);
    },
    removeOption(index) {
      this.buttons.splice(index, 1);
      setTimeout(() => {
        this.emitData();
      }, 0);
    },
    enterPressed(e) {
      // console.log('enterPressed', this.schema.enter.toLowerCase());
      // console.log(e);
      if (e.target.value.length && this.schema.enter && this.schema.enter.toLowerCase() === 'add') {
        this.addNewButtons();
      }
    },
    resetValidation() {
      if (this.$refs.buttonsObserver) this.$refs.buttonsObserver.reset();
    },
    /**
     * Sets the data for the buttons from the outside component mostly for edit purposes
     * @param {Array} buttonList List of buttons to set. Each button should be a string. e.g. ['button1', 'button2', 'button3']
     */
    setData(buttonList) {
      this.buttons = Array.isArray(buttonList) ? buttonList.map(button => ({ value: button })) : [];
    },
    emitData(reset = false) {
      // console.log(1);
      // console.log('this.$refs.buttonsObserver', this.$refs.buttonsObserver); return;
      if (!this.$refs.buttonsObserver) return;
      // console.log(2);
      this.$refs.buttonsObserver.validate({ silent: true })
        .then((valid) => {
          // console.log('EMIT');
          // console.log(3, valid);
          this.valid = valid;
          const filteredValues = this.buttons.map(button => button.value); // .filter(v => v); // removes empty strings // Filtering empty strings will mess up the conversation component for borders on message. Filtering is done on the parent element instead.
          this.$emit('input', {
            valid,
            name: this.schema.returnKey || '',
            data: {
              value: filteredValues.length ? filteredValues : [],
            },
          });
        })
        .finally(() => {
          // console.log('EMIT fin');
        //   if (reset) this.$refs.buttonsObserver.reset();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-start-image {
  top: 2px;
  position: relative;
}

.subtitle {
  line-height: 1.4;
  margin-bottom: 8px;
}

.button-fields {
  margin: 0 0 8px 0 !important;

  &:last-child {
    margin-bottom: 0 !important;
  }

  .form-group {
    margin: 0 0 0 0 !important;
    padding: 0 0 0 0 !important;;
  }
}

.add-more-btn {
  display: inline-block;
  width: fit-content;
  color: $bluePrimary;
  padding: 0 0 0 0;
  // margin-top: 15px;

  &.black:not(.disabled) {
    color: $blackPrimary;
  }

  span {
    font-weight: 500;
    font-size: 14px;
  }

  &:hover {
    cursor: pointer;
    color: $blackPrimary;
    ::v-deep .sb-icon .mask {
      background-color: $blackPrimary !important;
    }
  }

  &.disabled {
    pointer-events: none;
    color: $greyLight !important;

    ::v-deep .icon.mask {
      background-color: $greyLight !important;
    }
  }
}

.button__label {
  margin-bottom: 5px !important;

  .character-counter {
    color: $blackUltralight;
  }
}

.option {
  position: relative;
  height: 34px;

  .option-item {
    margin-bottom: 10px;
    padding-right: 30px;
  }

  .delete {
    position: absolute;
    top: 7px !important;
    right: 7px !important;
    margin-right: 0 !important;
    cursor: pointer;
  }

  &:hover {
    .delete {
      display: flex;
    }
  }
}

.error * {
  font-size: 12px !important;
  line-height: 1 !important;
}

.center {
  text-align: center;

  .button-fields input {
    text-align: center;
  }

  .add-more-btn {
    margin: 0 auto;
  }

  .error {

  }
}
</style>
